// @vendors
import React, { useMemo } from 'react'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

import {
    Box,
    Card,
    Typography,
    LinearProgress,
} from '../shared/MaterialUI'
import { EmployeeDetailStyles } from '../../assets/css/employeeTable-style';

const CardProgress = ({ employeeInfo }) => {
  const styles = useMemo(() => EmployeeDetailStyles(), []);

  const dataToShowProgress = {
    groups: employeeInfo?.qualifie || employeeInfo?.subQualifie,
    eligibility: employeeInfo?.qualifie || employeeInfo?.subQualifie,
    submit: employeeInfo?.submitterPreprocessStatus,
    stateCertification: employeeInfo?.stateCertification
  }

  const handleProgress = () => {
    let progress = 0;
    Object.values(dataToShowProgress).forEach(value => {
        if (value) progress += 1;
    });
    return (progress / Object.keys(dataToShowProgress).length) * 100;
  }

  return (
    <Card 
        elevation={1}
        sx={{...styles.cardProgress, height: '100%'}}
    >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Box sx={styles.cardProgressContainerTitle}>
                <TaskAltOutlinedIcon sx={styles.cardProgressIcon} />
                <Typography 
                    variant="body1" 
                    sx={{
                      ...styles.employeeDetailTypographicBox,
                      fontWeight: 'bold',
                    }}
                >
                    {`Progress completed ${handleProgress()}%`}
                </Typography>
            </Box>
            
            <LinearProgress 
                variant="determinate" 
                value={handleProgress()}
                sx={styles.cardLinearProgress}
            />
            
            <Typography 
                variant="body2"
                sx={styles.cardProgressPending}
            >
               <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Pending: </span>
               {Object.keys(dataToShowProgress).filter(key => !dataToShowProgress[key]).join(', ')}
            </Typography>
        </Box>
    </Card>
  )
}

export default CardProgress